import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';

export default function SearchBar({
    value,
    setValue,
    placeholder,
    searchActive,
    onClear,
    onPaste,
    classStyles = {}
}) {

    function onSearchInput(e) {
        let newVal = e.target.value;

        newVal = newVal.replace(/^\s+/, "");
        newVal = newVal.replace(/\s{2,}/g, " ");

        setValue(newVal);
    }

    return (
        <TextField
            value={value}
            onChange={onSearchInput}
            onKeyDown={(e) => {
                if (e.key === " " && value === '') e.preventDefault();
            }}
            onPaste={onPaste}
            placeholder={placeholder}
            size="small"
            sx={{ width: "100vw", borderRadius: "10px", ...classStyles }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        {!searchActive ? (
                            <SearchIcon fontSize="small" sx={{ color: "darkblue" }} />
                        ) : (
                            <button onClick={onClear}>
                                <CancelIcon fontSize="small" sx={{ color: "#d3d3d3" }} />
                            </button>
                        )}
                    </InputAdornment>
                ),
            }}
        />
    );
}
